import {Ref} from "vue";
import {FormValidation} from "@km/mixins/formValidation";

type ExpressAnfrageValues = {
    name:Ref<string>,
    termin:Ref<string>,
    productAndAmount:Ref<string>,
    ort:Ref<string>,
    message:Ref<string>,
    email:Ref<string>,
    telefon:Ref<string>,
    acceptPrivacy:Ref<boolean>
}



export function getExpressAnfrageErrors(formdata:ExpressAnfrageValues):string[] {
    return FormValidation.validate(
        {"email":formdata.email},
        {"name":formdata.name, message:formdata.message, productAndAmount:formdata.productAndAmount},
        {acceptPrivacy:formdata.acceptPrivacy})

}
